<ul class="links-footer">
    <li><a class="links-footer__item" href="http://www.serasaexperian.com.br/quem-somos/seguranca/">Segurança</a></li>
    <li><a class="links-footer__item" href="https://www.serasa.com.br/politicas-do-site">Política de Privacidade</a></li>
    <li><a class="links-footer__item" href="http://www.serasaexperian.com.br/quem-somos/seguranca/comunicado-importante/">Comunicação Importante</a></li>
    <li><a class="links-footer__item" href="http://www.procon.sp.gov.br/">Acesso ao Procon</a></li>
    <li><a class="links-footer__item" href="https://sitenet05.serasa.com.br/LogonPersonalizado/orgaosdefesa/Logon2.aspx">Órgãos de Defesa do Consumidor</a></li>
</ul>
